module.exports = __webpack_public_path__ + "img/OBCINA DOMZALE.7eacc6dd.png";